import { createFileRoute } from '@tanstack/react-router'
import { subscriptionSearchSchema } from '../../../features/platform/search'
import { SubscriptionsPage } from '../../../features/platform/subscriptions-page'

export const Route = createFileRoute('/platform/_console/subscriptions')({
  validateSearch: subscriptionSearchSchema,
  component: SubscriptionsPage,
})
